import { useEffect, useRef } from 'react';
import { playLoadingSfx } from '../../assets/preloadSounds';
import { useAppStore } from '../../store/appStore';
import { createLoadingScreenModel } from './LoadingScreenModelScreen';
import { LoadingScreenController } from './LoadingScreenController';
import { LoadingScreenView } from './LoadingScreenView';

export type { LoadingScreenProps } from './LoadingScreenModelScreen';

type LoadingScreenConnectedProps = {
  onContinue?: () => void;
};

export function LoadingScreen(props: LoadingScreenConnectedProps) {
  const assetsReady = useAppStore((s) => s.assetsPreloadStatus === 'ready');
  const assetsPreloadProgress = useAppStore((s) => s.assetsPreloadProgress);
  const continuedRef = useRef(false);
  const onContinueRef = useRef(props.onContinue);
  onContinueRef.current = props.onContinue;

  const progress =
    assetsReady
      ? 1
      : assetsPreloadProgress != null && assetsPreloadProgress.total > 0
        ? assetsPreloadProgress.loaded / assetsPreloadProgress.total
        : 0;

  useEffect(() => {
    if (!assetsReady || continuedRef.current) {
      return;
    }
    continuedRef.current = true;
    playLoadingSfx();
    onContinueRef.current?.();
  }, [assetsReady]);

  const model = createLoadingScreenModel({ progress });
  const controller = new LoadingScreenController(model);

  return <LoadingScreenView model={model} controller={controller} />;
}
